<div class="table-title card-header"
     [style.border-bottom-color]="state === 'collapsed' ? '$main-orange' : null">
  <div class=" table-header d-flex align-items-center">
    <div class="d-flex align-items-center">
      <h4 class="mb-0">
        <a>
          <i [ngClass]="state === 'collapsed' ? 'fa fa fa-arrow-down' : 'fa fa fa-arrow-up'" (click)="toggle()"></i>
        </a>
        {{ TABLE_TITLE }}
      </h4>
      <button class="mat-focus-indicator btn-excel ml-3 mat-icon-button mat-button-base"
              mat-icon-button
              (click)="downloadExcel()"
              *ngIf="(userIsProfessional || userIsAdmin) && !downloadExcelLoader.isActive()">
        <i class="fa fa-file-excel-o" aria-hidden="true"></i>
      </button>
      <app-loader class="ml-4" *ngIf="downloadExcelLoader.isActive()"></app-loader>
    </div>
    <button type="button" class="btn btn-light" *ngIf="tableInfoExists" (click)="openInfoDialog()">
      <i class="fa fa-info-circle fa-sm"></i>
    </button>
  </div>
</div>

<div class="table-responsive"
     [@detailExpand]="state">
  <table class="table footable" data-breakpoints='{ "xs": 480, "sm": 768, "md": 992, "lg": 1200, "xl": 1400 }' matSort
         (matSortChange)="triggerSorting($event)">
    <thead class="thead-dark">
    <tr>
      <th mat-sort-header="{{header[0]}}" *ngFor="let header of TABLE_SORT_HEADERS">
        {{ header[1] }}
      </th>
      <th></th>
    </tr>
    </thead>

    <tbody>
    <tr *ngIf="loader.isActive()">
      <td colspan="10">
        <div class="loader-container">
          <app-loader></app-loader>
        </div>
      </td>
    </tr>

    <tr *ngIf="dataStatus.isFailed()">
      <td colspan="10">
        <div class="alert" role="alert" [ngClass]="dataStatus.errorCSS()">
          {{ dataStatus.errorMessage }}
        </div>
      </td>
    </tr>

    <tr *ngIf="dataStatus.thereIsInfo()">
      <td colspan="10">
        <div class="alert" role="alert" [ngClass]="dataStatus.infoCSS()">
          {{ dataStatus.infoMessage }}
        </div>
      </td>
    </tr>

    <ng-container *ngIf="dataStatus.isSuccesfully()">
      <tr *ngFor="let record of records">
        <td>
          <a [routerLink]="['/menu/scheda-certificato']" [queryParams]="{ isin: record.isin }">
            {{ record.isin ? record.isin : '--' }}
          </a>
        </td>
        <td>{{ record.emittente ? record.emittente : '--' }}</td>
        <td>{{ record.nome ? record.nome : '--' }}</td>
        <td>{{ record.scadenza ? (record.scadenza | date: 'dd/MM/yyyy') : '--' }}</td>
        <td>{{ record.divisa ? record.divisa : '--' }}</td>
        <td>{{ record.ask ? (record.ask| number:'1.0-2':'fr') : '--' }}</td>
        <td>{{ record.rimborso ? record.rimborso : '--' }}</td>
        <td [style.color]=" record.rendimentoAssoluto < 0 ? 'red' : 'null'">
          {{ record.rendimentoAssoluto ? (record.rendimentoAssoluto / 100 | percent:'1.0-2':'fr') : '--' }}
        </td>
        <td [style.color]=" record.rendimentoAnnuo < 0 ? 'red' : 'null'">
          {{ record.rendimentoAnnuo ? (record.rendimentoAnnuo / 100 | percent:'1.0-2':'fr') : '--' }}
        </td>
        <td>{{ record.mercato ? record.mercato : '--' }}</td>
        <td>
          <a (click)="addIsinToWatchlist(record.isin)" matTooltip="Aggiungi isin ad una watchlist">
            <img [src]="'assets/images/icons/addToWatchlistGlassesSmall.png'" alt="Aggiungi alla watchlist" class="watchlistIcon">
          </a>
        </td>
      </tr>
    </ng-container>
    </tbody>

    <tfoot *ngIf="!loader.isActive()" class="footer-view-all">
    <tr>
      <td colspan="10">
        <a class="nav-link" [routerLink]="[VIEW_ALL_PATH]">
          <i class="fa fa-plus"></i> Visualizza tutti
        </a>
      </td>
    </tr>
    </tfoot>
  </table>
</div>
